import React from 'react'
import Home from './Pages/Home/Home'
import Header from './Layouts/Header/Header'
import Quiz from './Pages/Quiz/Quiz'
import { Routes, Route } from 'react-router-dom'

const App = () => {
  return (
    <>
      <Header />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/quiz' element={<Quiz />} />
      </Routes>
    </>
  )
}

export default App
